import {packagesStore} from '../stores/Packages';
import {displayDependentPacksConfirm} from '../../../../_shared/Messages/actions/MessageActions';
import {hiddenFieldTypes} from '../../../../constants/FieldConsts';
import * as screenTypes from '../../../../constants/ScreenTypes';
import * as treePackageActions from '../derivatives/TreeDesign/actions/Packages';
import * as splittedDesignPackageActions from '../derivatives/SplittedDesign/actions/Packages';
import {getLocalizedText, texts} from '../../../../constants/TextConst';

let updatePackageDataFunc;
let checkPackDepends;

export function initFunctions(funcs) {
    updatePackageDataFunc = funcs.updatePackageData;
    checkPackDepends = funcs.checkPackDepends;
}

export function getFieldPack(field) {
    return packagesStore.getFieldPack(field.packageId);
}

export function hideOrShowPackages(field, confirmCallback, cancelCallback) {
    const pack = {name: field.packageId, hidden: getFieldPack(field).hidden};
    checkPackDepends(pack, depPacks =>
        processPackDependencies(field, depPacks, confirmCallback, cancelCallback)
    );
}

function processPackDependencies(field, depPacks, confirmCallback, cancelCallback) {
    const packagesIds: string[] = [field.packageId];
    const packagesTitles: string[] = [];
    if (!depPacks) {
        cancelCallback();
    } else {
        for (const pack of depPacks) {
            /* need this check because id of the original package also returns from the server, moreover twice */
            if (pack.name !== field.packageId) {
                packagesIds.push(pack.name);
                packagesTitles.push(pack.title);
            }
        }
        if (packagesIds.length > 1) {
            displayDependentPacksConfirm(
                getFieldPack(field).title,
                packagesTitles,
                depPacks[0].packageHidden
                    ? getLocalizedText(texts.hidePackWarn)
                    : getLocalizedText(texts.showPackWarn),
                () => _processPackDependencies(field, packagesIds, confirmCallback),
                cancelCallback
            );
        } else {
            _processPackDependencies(field, packagesIds, confirmCallback);
        }
    }
}

function _processPackDependencies(field, packagesIds, confirmCallback) {
    const {screen} = field;
    if (!screen.changed) {
        screen.setChanged(true);
    }

    // we need to pass current hidden status of the active pack
    // to update appropriately the status of package unused in this form (so we don't know thir cirrent hidden statys)
    // but included into pack dependencies (so we need to update them)
    const curHidden = getFieldPack(field).hidden;
    for (const packageId of packagesIds) {
        packagesStore.hideOrShowPack(packageId, !curHidden);
    }
    if (screen.name === screenTypes.design.TREE) {
        treePackageActions.updateFieldsHiddenStatus(screen.collection, packagesIds);
    } else {
        if (screen.isSplitted) {
            splittedDesignPackageActions.updateFieldsHiddenStatus(screen, packagesIds);
        } else {
            updateFieldsHiddenStatus(screen.collection, packagesIds);
        }
    }
    field.setMoved(true);
    confirmCallback();
}

export function updateFieldsHiddenStatus(collection, packagesIds?) {
    const {fields} = collection;
    for (const field of fields) {
        checkAndUpdateFieldHiddenStatus(field, packagesIds);
    }
    collection.sortHidden();
}

export function checkAndUpdateFieldHiddenStatus(field, packagesIds) {
    const hideField = packagesIds
        ? packagesIds.includes(field.packageId)
        : isPackageChanged(getFieldPack(field), field);
    if (hideField) {
        updateFieldHiddenStatus(field, field.packageId);
    }
}

export function isPackageChanged(pack, field) {
    return (
        pack &&
        ((pack.hidden && field.hidden !== hiddenFieldTypes.PACKAGE_HIDDEN) ||
            (!pack.hidden && field.hidden === hiddenFieldTypes.PACKAGE_HIDDEN))
    );
}

export function updateFieldHiddenStatus(field, fieldPackId) {
    if (getFieldPack(field).hidden) {
        // don't change field hidden status to package hidden if
        // the field is already hidden in this form
        // or the field is a "needed" one
        if (field.hidden !== hiddenFieldTypes.HIDDEN && !field.needed) {
            field.setHide(hiddenFieldTypes.PACKAGE_HIDDEN);
            field.setNewArea && field.setNewArea(false);
        }
    } else {
        if (field.hidden !== hiddenFieldTypes.HIDDEN) {
            field.setHide(false);
        }
    }
}

export function getPacksToUpdate() {
    const packsToUpdate: Array<{name: string; hidden: boolean}> = [];

    for (const p of packagesStore.packages.keys()) {
        const pack = packagesStore.packages.get(p);
        if (
            (pack.unusedPack && !pack.isSaved) ||
            (pack.initialHidden !== undefined && pack.initialHidden !== pack.hidden)
        ) {
            packsToUpdate.push({name: p.toString(), hidden: pack.hidden});
            if (!pack.unusedPack) {
                delete pack.initialHidden;
            } else {
                pack.isSaved = true;
            }
        }
    }
    return packsToUpdate;
}

export function updatePackData(field) {
    const packId = field.packageId;
    if (
        packId &&
        (!packagesStore.getFieldPack(packId) || packagesStore.getFieldPack(packId).unusedPack)
    ) {
        updatePackageDataFunc(packId, data => {
            packagesStore.addPackageDataItem(packId, data[0]);
        });
    }
}
